// PercentageBarChart.jsx
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  ChartDataLabels
);

const PercentageBarChart = ({ chartData }) => {
  const total = chartData.reduce((sum, item) => sum + item.value, 0);
  const labels = chartData.map((item) => item.name);
  const percentages = chartData.map((item) =>
    ((item.value / total) * 100).toFixed(0)
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Percentage",
        data: percentages,
        backgroundColor: "#EC2100 ",
        borderRadius: 0,
        barThickness: 20, // 👈 thinner bar
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: false },
      datalabels: {
        color: "#000",
        anchor: "end",
        align: "end",
        formatter: (value) => `${value}%`,
        font: {
          weight: "bold",
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y}%`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => `${value}%`,
          stepSize: 5,
        },
        max: 25,
      },
    },
  };

  return (
    <div style={{ maxWidth: 900, margin: "0 auto" }}>
      <Bar data={data} options={options} plugins={[ChartDataLabels]} />
    </div>
  );
};

export default PercentageBarChart;
